import React, { useState, useEffect, useReducer } from 'react'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

function GetExternalSource(props) {
    const [tabData, setTabData] = useState([])
    const [open, setOpen] = useState(false)
    const [selectedIndividualCells, setSelectedIndividualCells] = useState([])
    const [currentTab, setCurrentTab] = useState(0)
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    // trigger on component mount
    useEffect(() => {
        setTabData(props.previewData)
    }, [])

    useEffect(() => {
        if (props.open !== open) {
            setOpen(props.open)
        }
    }, [props.open])

    useEffect(() => {
        if (tabData.length !== props.previewData.length) {
            setTabData(props.previewData)
        }
    }, [props.previewData])

    function renderTableOrMessageStatingNothingWasSelected() {
        if (tabData.length > 0) {
            return <Tabs value={currentTab} onChange={(event, newValue) => setCurrentTab(newValue)} aria-label="Preview Data Tabs" variant="scrollable">
                {tabData.map((tab, index) => {return <Tab key={`tab-data-${index}`} label={tab["tabName"]} {...a11yProps(index)} />})}
            </Tabs>
        }

        return null
    }

    /**
     * renderSelectedPreviewDataPanel
     * * Rander the tabed area with the preview snapshot of the data
    */
    function renderSelectedPreviewDataPanel() {
        if (tabData.length > currentTab) {
            return <TableContainer component={Paper} style={{ overflowY: "none", "cursor": "default" }}>
                <Table size="small" aria-label="preview data">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            {tabData[currentTab].previewData[0].map((tabInfo, tabInfoIndex) => {
                                return <TableCell key={`row-excel-header-${tabInfoIndex}`} align="center">{props.getExcelColumnName(tabInfoIndex + 1)}</TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tabData[currentTab].previewData.map((tabInfo, tabInfoIndex) => {
                            return <TableRow
                                key={`tab-${currentTab}-row-${tabInfoIndex}`}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, "cursor": (tabInfoIndex === 0) ? "pointer" : "default" }}>
                                    <TableCell>{tabInfoIndex+1}</TableCell>
                                    {renderPreviewRow(tabInfo, tabInfoIndex, currentTab)}
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        }

        return null
    }

    function updateIndividualCellSelections(rowIndex, colIndex) {
        let updated = []
        updated.push({ "row": rowIndex, "column": colIndex })
        setSelectedIndividualCells(updated)
    }

    /** 
     * renderPreviewRow
     * * Render the row on the preview data tab
     * @param {Array} tabInfo - Preview Data
     * @param {int} rowIndex - Current row index
    */
    function renderPreviewRow(tabInfo, rowIndex, tabIndex) {
        return tabInfo.map((data, index) => {
            return <TableCell
                key={`tab-${tabIndex}-row-${rowIndex}-cell-${index}`}
                align="center"
                style={{
                    "backgroundColor" : isThisCellSelected(selectedIndividualCells, rowIndex, index) ? props.uiColors.GRID_HIGHLIGHT : props.uiColors.REGULAR
                }}
                onClick={(e) => {
                    e.preventDefault()
                    updateIndividualCellSelections(rowIndex, index)
                    forceUpdate()
            }}>
                {data}
            </TableCell>
        })
    }

     /**
     * isThisCellSelected
     * * Determines if the cell needs to be highlighted as selected or not
     * @param {int[]} cols - Entire columns
     * @param {Array} cells - Individual Cells
     * @param {int} rowIndex - Cell row
     * @param {int} colIndex - Cell column
     * @returns {bool} True is the row needs to be highlighted
    */
     function isThisCellSelected(cells, rowIndex, colIndex) {
        for (let x = 0; x < cells.length; x++) {
            if (cells[x]["row"] === rowIndex && cells[x]["column"] === colIndex) {
                return true
            }
        }

        return false
    }
    
    return <Dialog open={open} maxWidth="lg" fullWidth>
        <CloseIcon onClick={(e) => {
            e.preventDefault()
            
            // Fire off external onClose
            if (props.onClose) {
                props.onClose()
            }
        }} className="closePoup" />
        <DialogTitle>Get External Source</DialogTitle>
        <DialogContent>
            <DialogContentText>Select an cell from an external sheet.</DialogContentText>
            {renderTableOrMessageStatingNothingWasSelected()}
            {renderSelectedPreviewDataPanel()}
        </DialogContent>
        <DialogActions disableSpacing={false} style={{ justifyContent: "center" }}>
            <Button className="btn" variant="contained" disabled={false} onClick={(e) => {
                if (props.onSave && selectedIndividualCells.length > 0) {
                    props.onSave({
                        "name": `Sheet:${tabData[currentTab]["tabName"]}!${props.getExcelColumnName(selectedIndividualCells[0]["column"] + 1)}${selectedIndividualCells[0]["row"] + 1}`,
                        "rowIndex": selectedIndividualCells[0]["row"],
                        "colIndex": selectedIndividualCells[0]["column"],
                        "useNulls": false,
                        "useProperCase": false,
                        "extractor" : { "extractorType": "", "numberOfWords": 0, "inverse" : false, "after" : 0, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": -1 }
                    })
                }

                if (props.onClose) {
                    props.onClose()
                }
            }}>
                OK
            </Button>
            <Button className="btn" variant="contained" disabled={false} onClick={(e) => {
                if (props.onClose) {
                    props.onClose()
                }
            }}>
                Cancel
            </Button>
        </DialogActions>
    </Dialog>
}

export default GetExternalSource